<!-- Макет: https://www.figma.com/file/reAk2sU4YpRajpQu2YBOHk/002%2F1.-%D0%AD%D0%BB%D0%B5%D0%BC%D0%B5%D0%BD%D1%82%D1%8B?type=design&node-id=8799-185540&mode=design&t=qSX2TGqlj5k9PCse-0-->
<template>
  <div class="goods">
    <a
      class="goods__image-link"
      :href="goods.link"
      target="_blank"
      @click="trackImageClick"
    >
      <img
        v-if="goods.image"
        class="goods__image"
        :src="goods.image.url"
        :width="goods.image.width"
        :height="goods.image.height"
        :alt="goods.title"
      />
    </a>
    <div class="goods__content">
      <div
        v-if="goods.title"
        class="goods__title"
      >
        {{ goods.title }}
      </div>
      <div
        v-if="goods.price"
        class="goods__price"
      >
        {{ goods.price }}
      </div>
      <div
        class="goods__description"
        @click="trackDescriptionLinkClick"
      >
        <TheContent
          v-for="content of goodsContent"
          :key="content.id"
          :elem="content"
        />
      </div>
      <a
        v-if="goods.button_text"
        class="goods__button"
        :href="goods.link"
        target="_blank"
        @click="trackButtonClick"
        >{{ goods.button_text }}</a
      >
    </div>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import TheContent from '../../TheContent';

  export type TGoods = {
    link?: string;
    image?: {
      url: string;
      width: number;
      height: number;
    };
    price?: string | number;
    title?: string;
    button_text?: string;
  };

  export default defineNuxtComponent({
    name: 'Goods',

    components: { TheContent },

    props: {
      elem: {
        type: Object as PropType<TContent<TGoods>>,
        required: true,
      },
    },

    computed: {
      goods(): TGoods {
        return this.elem.attributes;
      },

      goodsContent(): TContent[] {
        return this.elem.children;
      },
    },

    methods: {
      trackImageClick() {
        this.sendAnalyticsData({
          name: 'Клик_изображение товара',
        });
      },

      trackButtonClick() {
        this.sendAnalyticsData({
          name: 'Клик_кнопка товара',
          buttonName: this.goods.button_text,
        });
      },

      trackDescriptionLinkClick(event: any) {
        if (!event.target) {
          return;
        }
        const parentLink = (event.target as HTMLElement).closest('a');
        if (!parentLink) {
          return;
        }

        this.sendAnalyticsData({
          name: 'Клик_ссылка в товаре',
          to: parentLink.href,
        });
      },

      sendAnalyticsData({
        name,
        to,
        buttonName,
      }: {
        name: string;
        to?: string;
        buttonName?: string;
      }) {
        this.$sendYandexMetrika({
          level1: name,
          level4: to || this.goods.link,
          level5: buttonName || '',
        });
      },
    },
  });
</script>

<style lang="scss" scoped>
  .goods {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin: 24px 0;
    padding: 16px;

    & + & {
      margin-top: -24px;
    }

    h2 + &,
    h3 + &,
    h4 + & {
      margin-top: 4px;
    }

    @include tablet {
      padding: 16px 0;
      flex-direction: row;
    }

    &__image-link {
      display: flex;
      flex-direction: column;
      align-items: center;
      min-width: 224px;
    }

    &__image {
      display: block;
      height: auto;
      min-height: 224px;
      max-height: 336px;
      width: 224px;
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      overflow: hidden;
      object-fit: cover;
    }

    &__content {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    &__title {
      @include normalText;
      font-family: $secondFont;
      font-weight: 600;
      margin-bottom: 8px;
      text-align: center;
      flex-shrink: 0;

      @include tablet {
        @include mediumText;
        @include lineClampEllipsis(2);
        text-align: left;
      }
    }

    &__price {
      @include normalText;
      font-family: $secondFont;
      font-weight: 600;
      color: var(--main-color-2);
      margin-bottom: 8px;
      text-align: center;

      @include tablet {
        text-align: left;
      }
    }

    &__description {
      flex-shrink: 1;

      p,
      ul,
      ol {
        margin-bottom: 16px;
      }

      li:not(:last-child) {
        margin-bottom: 6px;
      }
    }

    &__button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      @include normalText;
      font-weight: 700;
      color: #fff;
      background-color: var(--main-color-2);
      min-width: 120px;
      border-radius: 2px;
      align-self: center;
      margin-top: 8px;
      margin-bottom: 8px;
      padding: 8px 24px;
      text-align: center;
      text-decoration: none;

      &:hover,
      &:focus {
        background-color: var(--hover-color-2);
      }

      @include tablet {
        align-self: flex-start;
      }
    }
  }
</style>
